module.exports = "https://jsak.mmtcdn.com/tripmoney/static/media/Air India SBI Platinum Card.a127e0d6.png";